<template>
  <div
    v-if="curStockHoldings.length || curStockOrders.length"
    class="holding-order-combine"
  >
    <section v-if="curStockHoldings.length" class="holdings-field">
      <h2 class="title">
        {{ $t('trade.stock-holdings') }}
      </h2>
      <HoldingsTable
        :holdings="curStockHoldings"
        setting-id="InTrade"
        @open-detail="openHoldingsDetail"
      />
    </section>
    <section v-if="curStockOrders.length" class="orders-field">
      <h2 class="title">
        {{ $t('trade.stock-open-order') }}
      </h2>
      <OrderTable
        :orders="curStockOrders"
        :symbol="symbol"
        :order-type="0"
        @openOrder="openOrderDetail"
        @orderCanceled="getStockHoldingsAndOrders"
      />
    </section>
  </div>
</template>
<script>
import HoldingsTable from 'mod/HoldingsTable'
import OrderTable from 'mod/OrderTable'
import { mapGetters } from 'vuex'
import stockHoldingPollMixin from 'mixins/stockHoldingPollMixin'

export default {
  name: 'HoldingOrderCombine',
  components: {
    HoldingsTable,
    OrderTable
  },
  mixins: [stockHoldingPollMixin],
  data() {
    return {
      orders: [],
      holdings: []
    }
  },
  props: {
    stock: { type: Object }
  },
  created() {
    this.getStockHoldingsAndOrders()
  },
  computed: {
    ...mapGetters([
      'language',
      'hasTradeRequest',
      'curStockHoldings',
      'curStockOrders',
      'latestOrderStatus',
      'isShowSideStockView',
      'curAccountId'
    ]),
    symbol() {
      return this.stock.webLocal
        ? this.stock.webLocal.symbol
        : this.stock.symbol
    }
  },
  methods: {
    getStockHoldingsAndOrders() {
      if (this.stock.isIndex) return
      this.$store.dispatch('getActiveStockHoldingsAndOrders', this.stock)
    },
    openHoldingsDetail(stock) {
      this.$emit('openHoldingsDetail', stock)
    },
    openOrderDetail(order) {
      this.$store.dispatch('setOrderDetail', order)
    }
  },
  watch: {
    isShowSideStockView(val) {
      // 期权链侧边栏关闭，更新个股所侧边列表
      if (!val) {
        this.getStockHoldingsAndOrders()
      }
    },
    symbol() {
      this.getStockHoldingsAndOrders()
    },
    hasTradeRequest(yes) {
      if (!yes) {
        this.getStockHoldingsAndOrders()
      }
    },
    latestOrderStatus(newValue) {
      if (newValue) {
        this.getStockHoldingsAndOrders()
      }
    },
    language() {
      this.getStockHoldingsAndOrders()
    },
    curAccountId() {
      this.getStockHoldingsAndOrders()
    }
  }
}
</script>
<style lang="less" scoped>
.holding-order-combine {
  .title {
    margin: 0;
    padding-left: 10px;
    line-height: 40px;
    border-bottom: 1px solid var(--special-color);
    font-size: 12px;
    text-align: left;
    color: var(--default-font-color);
  }
}
</style>
